import script from "./AreaChartSFIComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./AreaChartSFIComponent.vue?vue&type=script&setup=true&lang=js"

import "./AreaChartSFIComponent.vue?vue&type=style&index=0&id=76dd2fdc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76dd2fdc"]])

export default __exports__